export var CLASSNAME_PREFIX = 'av-document-types';
export var TRANSLATION_CONTEXT = 'accountverification';
//# sourceMappingURL=componentConfig.js.map